﻿////const { current } = require("../../js/scrollify");
var isIE = window.document.documentMode !== null;           // check if IE
window.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    } else {
        return decodeURI(results[1]) || 0;
    }
}


var urlParams = isIE ? null : new URLSearchParams(window.location.search);
var pageParams = {
    assetClass: isIE ? (urlParam('assetClass') || urlParam('assetclass')) : (urlParams.get('assetClass') || urlParams.get('assetclass')),
    investmentObjective: isIE ? (urlParam('investmentObjective') || urlParam('investmentobjective')) : (urlParams.get('investmentObjective') || urlParams.get('investmentobjective')),
    sortBy: isIE ? (urlParam('sortBy') || urlParam('sortby')) : (urlParams.get('sortBy') || urlParams.get('sortby')),
    sortDirection: isIE ? (urlParam('sortDirection') || urlParam('sortdirection')) : (urlParams.get('sortDirection') || urlParams.get('sortdirection')),
    sort: isIE ? urlParam('sort') : urlParams.get('sort')
};

const direction = { asc: 'asc', desc: 'desc' };
const column = { ticker: 'asx-code', name: 'name', oneYear: '1-yr', threeYear: '3-yr', fiveYear: '5-yr', sinceInception: 'since-inception', frequency: 'dividend-frequency', fee: 'fee', aum: 'aum' };
const enumAssetClass = { equity: 'equity', income: 'income', alternative: 'alternative' };
const enumInvestmentObjectives = { io: 'io' };
const platformType = { investment: 'investment', super: 'super' };
var isMenuJustActivated = false;
var etfSelectorData = null;
var lastCheckboxState = null;
var lastSortState = null;
var filterGroup = [];
var selectedFundsForComparison = [];
var isFundCompareActivated = false;
var today = new Date();
const pageType = { etfSelector: 'etf-selector', performance: 'performance', platformsRatings: 'platforms-ratings', documentListing: 'document-listing' };
const pageUrl = { etfSelector: '/vaneck-etfs/?page=etf-selector', etfPerformance: '/performance/vaneck-etfs/etf/?page=etf-performance', indexPerformance: '/performance/vaneck-etfs/index/?page=index-performance', platforms: '/platforms-and-ratings/?page=platforms', ratings: '/platforms-and-ratings/?page=ratings', documentListing: '/document-listing' };
var currentPageType = null;
var superPlatformState = $('input[id^=super-]');
var investmentPlatformState = $('input[id^=investment-]');
var currentPlatformType = platformType.investment;

// assetClasses is temporary. We need to set this up in Epi so that it can be modified on the fly
var assetClasses =
{
    equities: {
        'australian-equities': ['MVW', 'DVDY', 'MVS', 'MVE', 'MVA', 'MVR', 'MVB', 'GRNV'],
        'international-equities': ['GDX', 'IFRA', 'REIT', 'HLTH', 'HLTH', 'QUAL', 'QHAL', 'EMKT', 'ESGI', 'GOAT', 'MOAT', 'CNEW', 'CETF', 'QSML', 'VLUE', 'ESPO', 'CLNE'],
        'sustainable-and-esg': ['ESGI', 'GRNV', 'CLNE'],
        'sector-thematic': ['GRNV', 'MVA', 'MVR', 'MVB', 'GDX', 'IFRA', 'REIT', 'HLTH', 'ESPO', 'CLNE'],
        'smart-beta': ['MVW', 'DVDY', 'MVS', 'MVA', 'MVR', 'MVB', 'ESGI', 'GRNV', 'IFRA', 'HLTH', 'QUAL', 'QHAL', 'EMKT', 'GOAT', 'MOAT', 'CNEW', 'QSML', 'VLUE'],
    },
    income: {
        'australian-fi': ['PLUS', 'FLOT', 'SUBD'],
        'international-fi': ['EBND', 'GCAP']
    },
    alternative: {}
};

// investment objectives is temporary. We need to set this up in Epi so that it can be modified on the fly
var investmentObjectives =
{
    'io-income': ['DVDY', 'MVA', 'IFRA', 'REIT', 'PLUS', 'FLOT', 'SUBD', 'EBND', 'GCAP'],
    'io-growth': ['MVW', 'DVDY', 'MVS', 'MVE', 'MVA', 'MVR', 'MVB', 'GRNV', 'GDX', 'IFRA', 'REIT', 'HLTH', 'QUAL', 'QHAL', 'EMKT', 'ESGI', 'GOAT', 'CNEW', 'CETF', 'QSML', 'VLUE', 'ESPO', 'CLNE'],
    'io-sustainability-esg': ['ESGI', 'GRNV', 'CLNE'],
    'io-international-diversification': ['QUAL', 'QHAL', 'EMKT', 'GOAT', 'MOAT', 'CNEW', 'CETF', 'QSML', 'VLUE', 'IFRA', 'REIT', 'ESGI'],
    'io-factor-driven-performance': ['QUAL', 'QHAL', 'QSML', 'EMKT', 'CNEW', 'VLUE', 'MOAT', 'GOAT', 'DVDY'],
    'io-australian-equity-diversification': ['MVW', 'MVS', 'MVA', 'MVR'],
    'io-special-interest': ['ESPO', 'CLNE'],
    'io-trading-tools': ['GDX']
};

var investmentPlatforms = {};
var superPlatforms = {};
var ratingsLabels = {};
var documentListingLabels = {};

var M = 1000,
    B = 1000 * 1000,
    T = 1000 * 1000 * 1000;
var mulitpliers = {
    M: M,
    B: B,
    T: T
};

var parseNums = function (num) {
    num = num.replace('$', '');
    var a = num.charAt(num.length - 1);
    var b = mulitpliers[a];
    if (a == 'M' || a == 'B' || a == 'T') {
        num = new Number(num.replace(a, "")).toFixed(3) * 1000 * b;

    } else {
        num = 0;
    }
    return num;

}

var getRowCount = function (options) {
    options = options || {};

    var cssSelector = '';

    switch (currentPageType) {
        case pageType.etfSelector: cssSelector = '#etf-selector-main-data-table tbody tr:visible'; break;
        case pageType.performance: cssSelector = '#performance-main-data-table tbody tr:visible'; break;
        case pageType.platformsRatings: cssSelector = '#platforms-ratings-main-data-table tbody tr:visible'; break;
        case pageType.documentListing: cssSelector = '#document-listing-main-data-table tbody tr:visible'; break;
        default: cssSelector = '#etf-selector-main-data-table tbody tr:visible'; break;
    }

    $('.row-count').text($(cssSelector).length);

    if (options.getTotalRow) {
        $('.total-fund-count').text($(cssSelector).length);
    }
}

var processDictionaryString = function (str, prefix, isRatings, options) {
    if (options)
        return processDictionaryStringExtended(options);

    var items = [], result = { equities: {}, income: {}, alternative: {} };

    if (isRatings) {
        result = {};
        items = str.split('|');
        items.forEach(function (item) {
            if (item) {
                var key = item.split(':')[0];
                var value = item.split(':')[1];
                result[key] = value;
            }
        });
    } else {
        if (prefix) {
            result = {};
            items = str.split('|');
            items.forEach(function (item) {
                if (item) {
                    var key = prefix + item.split(':')[0];
                    var value = item.split(':')[1];
                    result[key] = value;
                }
            });
        } else {
            switch (str.substring(0, 2)) {
                case 'eq':
                    items = str.split('|');
                    items.forEach(function (item) {
                        if (item) {
                            var key = item.substring(0, item.indexOf(':'));
                            var value = item.substring(item.indexOf(':') + 1).split(';');
                            if (key.substring(0, 2) === 'eq') {
                                result['equities'][key] = value;
                            } else if (key.substring(0, 2) === 'fi') {
                                result['income'][key] = value;
                            } else if (key.substring(0, 2) === 'al') {
                                result['alternative'][key] = value;
                            }
                        }
                    });
                    break;
                case 'io':
                case 'do':
                    result = {};
                    items = str.split('|');
                    items.forEach(function (item) {
                        if (item) {
                            var key = item.substring(0, item.indexOf(':'));
                            var value = item.substring(item.indexOf(':') + 1).split(';');

                            result[key] = value;
                        }
                    });
                    break;
            }
        }
    }

    return result;
}

var processDictionaryStringExtended = function (options) {

}

var processUrlParams = function () {
    var tempStr = '', groups = [];

    if (pageParams.assetClass) {
        groups = pageParams.assetClass.split(',');
        groups.forEach(function (group) {
            group = group ? group.toLowerCase() : '';
            if (assetClasses.equities[group] || assetClasses.income[group] || assetClasses.alternative[group]) {
                tempStr += '#' + group + ','
            }
        });
    }

    if (pageParams.investmentObjective) {
        groups = pageParams.investmentObjective.split(',');
        groups.forEach(function (group) {
            group = group ? group.toLowerCase() : '';
            if (investmentObjectives[group] || investmentObjectives[group]) {
                tempStr += '#' + group + ','
            }
        });
    }

    if (tempStr) {
        var checkboxAllSelector = $('#all-equities, #all-income, #all-alternatives, #io-all');

        for (var i = 0; i < checkboxAllSelector.length; i++) {
            checkboxAllSelector[i].checked = false;
            checkboxAllSelector.trigger('change');
        }

        tempStr = tempStr.substring(0, tempStr.length - 1);
        var selectedCheckboxes = $(tempStr);

        for (var i = 0; i < selectedCheckboxes.length; i++) {
            selectedCheckboxes[i].checked = true;
            selectedCheckboxes.trigger('change');
        }
    }

    if (pageParams.sortBy) {            // to be deprecated as we are using pageParams.sort
        var sortDirection = pageParams.sortDirection || direction.asc;

        switch (pageParams.sortBy) {
            case column.ticker: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [0, 0] : [0, 1]]]); break;
            case column.name: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [1, 0] : [1, 1]]]); break;
            case column.oneYear: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [2, 0] : [2, 1]]]); break;
            case column.threeYear: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [3, 0] : [3, 1]]]); break;
            case column.fiveYear: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [4, 0] : [4, 1]]]); break;
            case column.sinceInception: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [5, 0] : [5, 1]]]); break;
            case column.frequency: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [6, 0] : [6, 1]]]); break;
            case column.fee: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [7, 0] : [7, 1]]]); break;
            case column.aum: $('#etf-selector-main-data-table').trigger('sorton', [[sortDirection === direction.asc ? [8, 0] : [8, 1]]]); break;
        }
    }

    if (pageParams.sort) {
        var segment = [];
        segment[0] = pageParams.sort.substring(0, pageParams.sort.indexOf(','));
        segment[1] = pageParams.sort.substring(pageParams.sort.indexOf(',') + 1);
        $('#etf-selector-main-data-table, #performance-main-data-table').trigger('sorton', [[segment]]);
    }
}

var initRatingsSearch = function () {
    $(document).ready(function () {
        $('input[id^=lonsec]').change(function (event) {
            var currentCheckbox = this;

            $('input[id^=lonsec]').each(function () {
                if (this != currentCheckbox) {
                    $(this)[0].checked = false;
                }
            });

            filterFunds(null, null, replaceSearchStringDelimiter($('.extended-fund-search').val()));
        });

        $('input[id^=zenith]').change(function () {
            var currentCheckbox = this;

            $('input[id^=zenith]').each(function () {
                if (this != currentCheckbox) {
                    $(this)[0].checked = false;
                }
            });

            filterFunds(null, null, replaceSearchStringDelimiter($('.extended-fund-search').val()));
        });

        $('input[id^=morningstar]').change(function () {
            var currentCheckbox = this;

            $('input[id^=morningstar]').each(function () {
                if (this != currentCheckbox) {
                    $(this)[0].checked = false;
                }
            });

            filterFunds(null, null, replaceSearchStringDelimiter($('.extended-fund-search').val()));
        });
    });
}

var getPillLabelAbbreviation = function (value) {
    if (value) {
        value = value.trim();

        if (value.indexOf(' ') < 0)
            return value.toUpperCase();

        var result = [value[0]];
        for (var i = 0; i < value.length; i++) {
            if (value[i] === ' ')
                result.push(value[i + 1]);
        }

        return result.join('').toUpperCase();
    }
}

var populateDocumentTypePills = function () {
    Object.keys(documentListingLabels).forEach(function (key) {
        var pill = '<span id="flp-' + key + '" class="filter-literature-pill">' + getPillLabelAbbreviation(documentListingLabels[key][0]) + '</span>';
        $('div.drop-down-container div.dropdown.document-type div.dropdown-text').append(pill);
    });
}

window.initEtfSelectorPage = function (options) {
    options = options || {};
    currentPageType = pageType.etfSelector;
    console.log('ETF Selector Page init');
    //getEtfSelectorData(options.pageId);
    assetClasses = processDictionaryString(options.assetClassGroups);
    investmentObjectives = processDictionaryString(options.investmentObjectiveGroups);
    initTableSorter({ tableId: '#etf-selector-main-data-table', sorterOptions: { headers: { 9: { sorter: 'marketCap' } }, widgets: ['stickyHeaders', 'filter'] } });
    getRowCount({ getTotalRow: true });
    setTimeout(processUrlParams, 250);      // allow time for checkboxes and triggering logic to initialise
}

window.initPerformancePage = function (options) {
    options = options || {};
    currentPageType = pageType.performance;
    assetClasses = processDictionaryString(options.assetClassGroups);
    initTableSorter({ tableId: '#performance-main-data-table', sorterOptions: { headers: { 10: { sorter: 'marketCap' } }, widgets: ['stickyHeaders', 'filter'] } });
    getRowCount({ getTotalRow: true });
    setTimeout(processUrlParams, 250);      // allow time for checkboxes and triggering logic to initialise
}

window.initPlatformsRatingsPage = function (options) {
    options = options || {};
    currentPageType = pageType.platformsRatings;
    assetClasses = processDictionaryString(options.assetClassGroups);
    initTableSorter({ tableId: '#platforms-ratings-main-data-table', sorterOptions: { widgets: ['stickyHeaders', 'filter'] } });
    getRowCount({ getTotalRow: true });

    if (options.isRatings) {
        ratingsLabels = processDictionaryString(options.ratingsLabels, null, true);
        initRatingsSearch();
    }
    else {
        investmentPlatforms = processDictionaryString(options.investmentPlatformLabels, 'investment-');
        superPlatforms = processDictionaryString(options.superPlatformLabels, 'super-');
    }
}

window.initDocumentListingPage = function (options) {
    options = options || {};
    currentPageType = pageType.documentListing;
    assetClasses = processDictionaryString(options.assetClassGroups);
    documentListingLabels = processDictionaryString(options.documentListingLabels);
    console.log(documentListingLabels);
    initTableSorter({ tableId: '#document-listing-main-data-table', sorterOptions: { widgets: ['stickyHeaders', 'filter'] } });
    getRowCount({ getTotalRow: true });
    populateDocumentTypePills();
    $('.filter-literature-pill').hide();
    $('#flp-all').show();
}

var getEtfSelectorData = function (pageId) {
    $.post('/Australia/FundListingAu/GetData/GetData', { pageId: pageId }, function (response) {
        console.log('Response:');
        etfSelectorData = JSON.parse(response);
        console.log(etfSelectorData);
    });
}

window.openDocumentsMenu = function (ticker) {
    var isOpen = $('.menu-' + ticker).hasClass('active');
    $('table .documents-menu').removeClass('active');

    if (!isOpen) {
        isMenuJustActivated = true;
        $('.menu-' + ticker).addClass('active');

        setTimeout(function () {
            isMenuJustActivated = false;        // this is used by outside click to dismiss documents menu
        });
    }
}

var initTableSorter = function (options) {
    options = options || {};
    $(function () {
        $.tablesorter.addParser({
            // set a unique id
            id: 'marketCap',
            is: function (s) {
                // return false so this parser is not auto detected
                return false;
            },
            format: function (s) {
                // format your data for normalization
                return parseNums(s);
            },
            // set type, either numeric or text
            type: 'numeric'
        });

        $(options.tableId).tablesorter(options.sorterOptions);
    });
}

var getPageUrlPath = function () {
    if (window.location.search.indexOf('=etf-selector') > -1) {
        return pageUrl.etfSelector;
    } else if (window.location.search.indexOf('=etf-performance') > -1) {
        return pageUrl.etfPerformance;
    } else if (window.location.search.indexOf('=index-performance') > -1) {
        return pageUrl.indexPerformance;
    } else if (window.location.search.indexOf('=platforms') > -1) {
        return pageUrl.platforms;
    }

    return '';
}

var updateHistoryState = function () {
    var excludedPages = [pageType.platformsRatings, pageType.documentListing];          // these pages will not use state tracking

    if (excludedPages.indexOf(currentPageType) < 0) {
        var assetClassQuerystring = '', investmentObjectiveQuerystring = '', finalQuerystring = '';

        Object.keys(assetClasses.equities).forEach(function (key) {
            if ($('#' + key)[0].checked) {
                assetClassQuerystring += key + ',';
            }
        });

        Object.keys(assetClasses.income).forEach(function (key) {
            if ($('#' + key)[0].checked) {
                assetClassQuerystring += key + ',';
            }
        });

        Object.keys(assetClasses.alternative).forEach(function (key) {
            if ($('#' + key)[0].checked) {
                assetClassQuerystring += key + ',';
            }
        });

        assetClassQuerystring = assetClassQuerystring.substring(0, assetClassQuerystring.length - 1);

        if (currentPageType === pageType.etfSelector) {
            Object.keys(investmentObjectives).forEach(function (key) {
                if ($('#' + key)[0].checked) {
                    investmentObjectiveQuerystring += key + ',';
                }
            });

            investmentObjectiveQuerystring = investmentObjectiveQuerystring.substring(0, investmentObjectiveQuerystring.length - 1);
        }

        if (assetClassQuerystring) {
            finalQuerystring += '&assetClass=' + assetClassQuerystring;
        }

        if (investmentObjectiveQuerystring) {
            finalQuerystring += '&investmentObjective=' + investmentObjectiveQuerystring;
        }

        if (lastSortState) {
            finalQuerystring += '&sort=' + lastSortState;
        }

        window.history.pushState('', '', getPageUrlPath() + finalQuerystring);
    }
}

var arrayMethods = {
    unique: function (value, index, self) {
        return self.indexOf(value) === index;
    },
    inclusive: function (value, joiningArray) {
        if (joiningArray && joiningArray.length) {
            return joiningArray.indexOf(value) > -1;
        }

        return true;
    }
};

var filterFunds = function (checkbox, assetClass, extendedSearchString) {
    var isAllEquitiesChecked = true;
    var isAllIncomeChecked = true;
    var isAllAlternativeChecked = true;
    var isAllInvestmentObjectives = true;
    var anyEquitiesChecked = false;
    var anyIncomeChecked = false;
    var anyAlternativeChecked = false;
    var anyInvestmentObjectiveChecked = false;
    var col = [];
    var textAssetClassDropdown = [];
    var textRatingsDropdown = [];
    var textInvestmentObjectiveDropdown = [];
    var filterGroupAssetClass = [];
    var filterGroupInvestmentObjective = [];
    var searchTerm = extendedSearchString ? '' : (currentPageType !== pageType.platformsRatings ? 'ASDFASDFWER#$%#$RWEFASASDF@#$%' : '');
    filterGroup = [];

    if (currentPageType !== pageType.platformsRatings) {        // this part applies to pages that are not Platforms and Ratings because it contains the Asset Class filter
        Object.keys(assetClasses.equities).forEach(function (key) {
            if ($('#' + key)[0].checked) {
                anyEquitiesChecked = true;
                filterGroupAssetClass = filterGroupAssetClass.concat(assetClasses.equities[key]);
            } else {
                isAllEquitiesChecked = false;
            }
        });

        if (assetClass === enumAssetClass.equity) {
            if (!checkbox.checked) {
                $('#all-equities')[0].checked = false;
            } else {
                $('#all-equities')[0].checked = isAllEquitiesChecked;
            }
        }

        Object.keys(assetClasses.income).forEach(function (key) {
            if ($('#' + key)[0].checked) {
                anyIncomeChecked = true;
                filterGroupAssetClass = filterGroupAssetClass.concat(assetClasses.income[key]);
            } else {
                isAllIncomeChecked = false;
            }
        });

        if (assetClass === enumAssetClass.income) {
            if (!checkbox.checked) {
                $('#all-income')[0].checked = false;
            } else {
                $('#all-income')[0].checked = isAllIncomeChecked;
            }
        }
        // alternatives
        Object.keys(assetClasses.alternative).forEach(function (key) {
            if ($('#' + key)[0].checked) {
                anyAlternativeChecked = true;
                //filterGroup = filterGroup.concat(assetClasses.income[key]);
                filterGroupAssetClass = filterGroupAssetClass.concat(assetClasses.alternative[key]);
            } else {
                isAllAlternativeChecked = false;
            }
        });
    }

    if (currentPageType === pageType.etfSelector || currentPageType === pageType.performance || currentPageType === pageType.documentListing) {
        if (assetClass === enumAssetClass.alternative) {
            if (!checkbox.checked) {
                $('#all-alternatives')[0].checked = false;
            } else {
                $('#all-alternatives')[0].checked = isAllAlternativeChecked;
            }
        }
    }

    if (currentPageType === pageType.etfSelector) {			// this part only applies to ETF Selector page because it contains the Investment Objectives filter
        Object.keys(investmentObjectives).forEach(function (key) {
            if ($('#' + key)[0].checked) {
                anyInvestmentObjectiveChecked = true;
                filterGroupInvestmentObjective = filterGroupInvestmentObjective.concat(investmentObjectives[key]);
            } else {
                isAllInvestmentObjectives = false;
            }
        });

        if (assetClass === enumInvestmentObjectives.io) {
            if (!checkbox.checked) {
                $('#io-all')[0].checked = false;
            } else {
                $('#io-all')[0].checked = isAllInvestmentObjectives;
            }
        }
    }

    filterGroupAssetClass = filterGroupAssetClass.filter(arrayMethods.unique);
    filterGroupInvestmentObjective = filterGroupInvestmentObjective.filter(arrayMethods.unique);

    if (currentPageType === pageType.platformsRatings) {            // platforms and ratings go through here
        var filterGroupInvestmentPlatform = '', filterGroupSuperPlatform = '', filterGroupRatings = '';

        if (filterGroupAssetClass.join('|')) {              // if any asset class is checked, add them to the search term
            searchTerm = '(' + filterGroupAssetClass.join('|') + ')';
        }

        if ($('#investment-platforms').hasClass('active')) {
            Object.keys(investmentPlatforms).forEach(function (key) {       // check what investment platforms are checked
                if ($('#' + key)[0].checked) {
                    filterGroupInvestmentPlatform += ' ' + key + ' ' + '&&';
                }
            });

            if (filterGroupInvestmentPlatform.length) {
                filterGroupInvestmentPlatform = filterGroupInvestmentPlatform.substring(1, filterGroupInvestmentPlatform.length - 3);   // remove the | character at the end

                if (searchTerm.indexOf('(') > -1) {             // search term contains at least 1 asset class
                    searchTerm += ' && ' + filterGroupInvestmentPlatform;       // add &&
                } else {
                    searchTerm = filterGroupInvestmentPlatform;         // if no asset class, just add the investment platforms to the search term
                }
            }
        }

        if ($('#super-platforms').hasClass('active')) {
            Object.keys(superPlatforms).forEach(function (key) {       // check what super platforms are checked
                if ($('#' + key)[0].checked) {
                    filterGroupSuperPlatform += ' ' + key + ' ' + '&&';
                }
            });

            if (filterGroupSuperPlatform.length) {
                filterGroupSuperPlatform = filterGroupSuperPlatform.substring(1, filterGroupSuperPlatform.length - 3);   // remove the | character at the end

                if (searchTerm.indexOf('(') > -1) {             // search term contains at least 1 asset class
                    searchTerm += ' && ' + filterGroupSuperPlatform;       // add &&
                } else {
                    searchTerm = filterGroupSuperPlatform;         // if no asset class, just add the super platforms to the search term
                }
            }
        }

        if (window.location.href.indexOf('?page=ratings') > -1) {
            Object.keys(ratingsLabels).forEach(function (key) {       // check what ratings are checked
                if ($('#' + key)[0].checked) {
                    filterGroupRatings += ' ' + key + ' ' + '&&';
                }
            });

            filterGroupRatings = filterGroupRatings.substring(1, filterGroupRatings.length - 3);
            searchTerm = filterGroupRatings;
        }

        if (extendedSearchString) {
            searchTerm = extendedSearchString + ' && ' + searchTerm;
        }

        lastCheckboxState = searchTerm;
    } else {            // all other pagetypes go through here
        if (filterGroupAssetClass.length > 0) {
            filterGroup = filterGroupInvestmentObjective;
        } else if (filterGroupInvestmentObjective.length > 0) {
            filterGroup = filterGroupAssetClass;
        } else {
            filterGroup = filterGroupAssetClass.filter(function (value) {
                return arrayMethods.inclusive(value, filterGroupInvestmentObjective);
            });
        }

        if (filterGroup && filterGroup.length > 0) {
            $.each(filterGroup, function (index, value) {
                if (value.toUpperCase().endsWith("AU")) {
                    filterGroup[index] = value.substring(0, value.length - 2);
                }
            });
        }

        searchTerm = lastCheckboxState = filterGroup.join('|') || searchTerm;
    }

    var cssSelector = '';

    switch (currentPageType) {
        case pageType.etfSelector:
            col[1] = searchTerm;
            $('#etf-selector-main-data-table').trigger('search', [col]);
            break;
        case pageType.performance:
            var isIndexPerformance = window.location.search.indexOf('=index-performance') > -1;
            col[isIndexPerformance ? 3 : 0] = searchTerm;
            $('#performance-main-data-table').trigger('search', [col]);
            break;
        case pageType.platformsRatings:
            col[currentPlatformType === platformType.investment ? 5 : 6] = searchTerm;
            $('#platforms-ratings-main-data-table').trigger('search', [col]);
            break;
        case pageType.documentListing:
            col[1] = searchTerm;
            $('#document-listing-main-data-table').trigger('search', [col]);
            break;
        default:
            col[1] = searchTerm;
            $('#etf-selector-main-data-table').trigger('search', [col]);
            break;
    }

    getRowCount();

    if (anyEquitiesChecked) {
        textAssetClassDropdown.push('Equities');
    }

    if (anyIncomeChecked) {
        textAssetClassDropdown.push('Income');
    }

    if (anyAlternativeChecked) {
        textAssetClassDropdown.push('Alternatives');
    }

    if (anyInvestmentObjectiveChecked) {
        textInvestmentObjectiveDropdown.push('Investment Objectives');
    }

    if (window.location.search.indexOf('=ratings') > -1) {
        if (filterGroupRatings.indexOf('lonsec') > -1) {
            textRatingsDropdown.push('Lonsec');
        }

        if (filterGroupRatings.indexOf('zenith') > -1) {
            textRatingsDropdown.push('Zenith');
        }

        if (filterGroupRatings.indexOf('morningstar') > -1) {
            textRatingsDropdown.push('Morningstar');
        }
    }

    if (textAssetClassDropdown.length > 0) {
        $('.dropdown.asset-class .dropdown-text').text(textAssetClassDropdown.join(', '));
    } else {
        $('.dropdown.asset-class .dropdown-text').text('None');
    }

    if (textInvestmentObjectiveDropdown.length > 0) {
        $('.dropdown.investment-objective .dropdown-text').text(textInvestmentObjectiveDropdown.join(', '));
    } else {
        $('.dropdown.investment-objective .dropdown-text').text('None');
    }

    if (textRatingsDropdown.length > 0) {
        $('.dropdown.ratings .dropdown-text').text(textRatingsDropdown.join(', '));
    } else {
        $('.dropdown.ratings .dropdown-text').text('Select rating');
    }

    updateHistoryState();
}

var searchFund = function (searchText, isCompareFund) {
    var col = [];

    var cssSelector = '';

    switch (currentPageType) {
        case pageType.etfSelector:
            cssSelector = '#etf-selector-main-data-table';
            col[1] = searchText;
            break;
        case pageType.performance:
            cssSelector = '#performance-main-data-table';
            col[0] = searchText;
            break;
        case pageType.platformsRatings:
            cssSelector = '#platforms-ratings-main-data-table';
            col[1] = searchText;
            break;
        case pageType.documentListing:
            cssSelector = '#document-listing-main-data-table';
            col[0] = searchText;
            break;
        default:
            cssSelector = '#etf-selector-main-data-table';
            col[1] = searchText;
            break;
    }

    $(cssSelector).trigger('search', [col]);

    if (searchText) {
        $('#dropdownMenu1, #dropdownMenu2').addClass('disabled');

        if (isCompareFund) {
            $('.fund-search, .extended-fund-search').addClass('disabled');
        }
    } else {
        $('#dropdownMenu1, #dropdownMenu2').removeClass('disabled');

        if (isCompareFund) {
            $('.fund-search, .extended-fund-search').removeClass('disabled');
        }

        if (lastCheckboxState) {
            switch (currentPageType) {
                case pageType.etfSelector:
                    col[1] = lastCheckboxState;
                    break;
                case
                    pageType.performance:
                    var isIndexPerformance = window.location.search.indexOf('=index-performance') > -1;
                    col[isIndexPerformance ? 3 : 0] = lastCheckboxState;
                    break;
                case pageType.platformsRatings:
                    col[1] = lastCheckboxState;
                    break;
                case pageType.documentListing:
                    col[1] = lastCheckboxState;
                    break;
                default:
                    col[1] = lastCheckboxState;
                    break;
            }

            $(cssSelector).trigger('search', [col]);
        }
    }
}

var replaceSearchStringDelimiter = function (searchText) {
    searchText = searchText.trim().replace(/ /g, ' && ');

    return searchText;
}

var toggleDocuments = function (checkbox) {
    var anyDocumentChecked = false;
    var isAllDocumentChecked = true;

    Object.keys(documentListingLabels).forEach(function (key) {
        var pill = '.literature-pill.' + documentListingLabels[key][0].replace(/ /g, '').toLowerCase();
        if ($('#' + key)[0].checked) {
            anyDocumentChecked = true;
            $(pill).show();
            $('#flp-' + key).show();
            $('#flp-all').hide();
        } else {
            $(pill).hide();
            $('#flp-' + key).hide();
            isAllDocumentChecked = false;
        }
    });

    if (!checkbox.checked) {
        $('#all-document')[0].checked = false;
    } else {
        $('#all-document')[0].checked = isAllDocumentChecked;
    }

    if (isAllDocumentChecked) {
        $('.filter-literature-pill').hide();
        $('#flp-all').show();
    }

    anyDocumentChecked ? $('#flp-none').hide() : $('#flp-none').show();
}

window.addEventListener("DOMContentLoaded", function () {
    var equitiesKey = '', incomeKey = '', investmentObjectiveKey = '', documentLabelKey = '', alternativesKey = '';

    setTimeout(function () {
        investmentPlatformState = $('input[id^=investment-]');
        superPlatformState = $('input[id^=super-]');

        Object.keys(assetClasses.equities).forEach(function (key) {
            equitiesKey += '#' + key + ', ';
        });

        Object.keys(assetClasses.income).forEach(function (key) {
            incomeKey += '#' + key + ', ';
        });

        Object.keys(assetClasses.alternative).forEach(function (key) {
            alternativesKey += '#' + key + ', ';
        });

        Object.keys(investmentObjectives).forEach(function (key) {
            investmentObjectiveKey += '#' + key + ', ';
        });

        Object.keys(documentListingLabels).forEach(function (key) {
            documentLabelKey += '#' + key + ', ';
        });

        equitiesKey = equitiesKey.substring(0, equitiesKey.length - 2);
        incomeKey = incomeKey.substring(0, incomeKey.length - 2);
        alternativesKey = alternativesKey.substring(0, alternativesKey.length - 2);
        investmentObjectiveKey = investmentObjectiveKey.substring(0, investmentObjectiveKey.length - 2);
        documentLabelKey = documentLabelKey.substring(0, documentLabelKey.length - 2);

        $(equitiesKey).change(function (event) {
            filterFunds(this, enumAssetClass.equity);
        });

        $(incomeKey).change(function (event) {
            filterFunds(this, enumAssetClass.income);
        });

        $(alternativesKey).change(function (event) {
            filterFunds(this, enumAssetClass.alternative);
        });

        $(investmentObjectiveKey).change(function (event) {
            filterFunds(this, enumInvestmentObjectives.io);
        });

        $(documentLabelKey).change(function (event) {
            toggleDocuments(this);
        });

        $('[id^=cb-]').change(function (event) {
            var fundname = this.id.substring(this.id.indexOf('-') + 1);

            if (fundname.slice(-2).toLowerCase() === 'au') {
                fundname = fundname.substring(0, fundname.indexOf('au'));
            } 

            if (this.checked && selectedFundsForComparison.indexOf(fundname) < 0) {
                selectedFundsForComparison.push(fundname);
            } else {
                selectedFundsForComparison.splice(selectedFundsForComparison.indexOf(fundname), 1);
            }

            if (selectedFundsForComparison.length) {
                $('.compare-funds').addClass('active');
            } else {
                $('.compare-funds').removeClass('active');
            }
        });

        $('input[id^=investment-], input[id^=super-]').click(function (event) {
            filterFunds(null, null, replaceSearchStringDelimiter($('.extended-fund-search').val()));
        });
    });

    $('.compare-funds').click(function () {
        if (!isFundCompareActivated) {
            searchFund(selectedFundsForComparison.join('|'), true);
            isFundCompareActivated = true;
            $('[id^=cb-], .fund-search, .extended-fund-search').attr('disabled', 'disable');
            $('.compare-funds').text('Undo');
        } else {
            searchFund('', true);
            isFundCompareActivated = false;
            $('[id^=cb-], .fund-search, .extended-fund-search').removeAttr('disabled');
            $('.compare-funds').text('Compare funds');

            if (currentPageType === pageType.platformsRatings) {
                filterFunds();      // platforms and ratings page uses a filter not only uses the ASX code column for searching, so method searchFund() will not work. Will need to use filterFunds() method to restore previous state
            }
        }

        getRowCount();
    });

    $('.fund-search').keyup(function () {
        searchFund($('.fund-search').val());

        getRowCount();
    });

    $('.extended-fund-search').keyup(function () {
        filterFunds(null, null, replaceSearchStringDelimiter($('.extended-fund-search').val()));
    });

    $('#all-equities').change(function () {
        var isChecked = this.checked;
        Object.keys(assetClasses.equities).forEach(function (key) {
            $('#' + key)[0].checked = isChecked;
            $('#' + key).trigger('change');
        });
    });

    $('#all-income').change(function () {
        var isChecked = this.checked;
        Object.keys(assetClasses.income).forEach(function (key) {
            $('#' + key)[0].checked = isChecked;
            $('#' + key).trigger('change');
        });
    });

    $('#all-alternatives').change(function () {
        var isChecked = this.checked;
        Object.keys(assetClasses.alternative).forEach(function (key) {
            $('#' + key)[0].checked = isChecked;
            $('#' + key).trigger('change');
        });
    });

    $('#io-all').change(function () {
        var isChecked = this.checked;
        Object.keys(investmentObjectives).forEach(function (key) {
            $('#' + key)[0].checked = isChecked;
            $('#' + key).trigger('change');
        });
    });

    $('#all-document').change(function () {
        var isChecked = this.checked;
        Object.keys(documentListingLabels).forEach(function (key) {
            $('#' + key)[0].checked = isChecked;
            $('#' + key).trigger('change');
        });

        if (isChecked) {
            $('.filter-literature-pill').hide();
            $('#flp-all').show();
        } else {
            $('#flp-all').hide();
        }
    });

    $('#etf-selector-main-data-table, #performance-main-data-table').on('sortEnd', function (event) {
        lastSortState = event.target.config.sortList[0];
        updateHistoryState();
    });

    $('.clear-filter-link').attr('href', getPageUrlPath());

    $('#investment-platforms').click(function () {
        if (!$(this).hasClass('active')) {
            currentPlatformType = platformType.investment;
            $(this).addClass('active');
            $('#super-platforms').removeClass('active');
            $('.investment-col').show();
            $('.super-col').hide();
            $('.menu-items.investments').addClass('active');
            $('.menu-items.super').removeClass('active');
            $('.dropdown.platforms .dropdown-text').text('Investment Platforms');
            filterFunds(null, null, replaceSearchStringDelimiter($('.extended-fund-search').val()));
        }
    });

    $('#super-platforms').click(function () {
        if (!$(this).hasClass('active')) {
            currentPlatformType = platformType.super;
            $(this).addClass('active');
            $('#investment-platforms').removeClass('active');
            $('.super-col').show();
            $('.investment-col').hide();
            $('.menu-items.investments').removeClass('active');
            $('.menu-items.super').addClass('active');
            $('.dropdown.platforms .dropdown-text').text('Super Platforms');
            filterFunds(null, null, replaceSearchStringDelimiter($('.extended-fund-search').val()));
        }
    });

// prevent closing drop down menu when clicking inside the menu
    setTimeout(() => {
$(document).on('click tap touchstart', '.drop-down-container .dropdown-menu', function (e) {
    e.stopPropagation();
});

// allow outside click to dismiss documents menu - uses the flag isMenuJustActivated to check if menu was recently opened so that it doesn't prevent menu from opening
// opening a menu is considered an outside click
$(document).click(function (e) {
    var activeMenu = $('.documents-menu.active');

    if (!activeMenu.is(e.target) && !activeMenu.has(e.target).length && !isMenuJustActivated) {
        activeMenu.removeClass('active');
    }
});
    });

    var getSearchParam = function (name) {
        var isIE = window.document.documentMode !== null;

        if (isIE) {
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results == null) {
                return null;
            } else {
                return decodeURI(results[1]) || 0;
            }
        } else {
            var urlParams = isIE ? null : new URLSearchParams(window.location.search);
            return urlParams.get(name)
        }
    }

    setTimeout(function () {
        var searchValue = getSearchParam('searchfield');

        if (searchValue) {
            $('input.fund-search').val(searchValue);
            setTimeout(function () {
                searchFund(searchValue);
            }, 100);
        }

        var filterValue = getSearchParam('filter');

        if (filterValue && filterValue.toLowerCase() === 'smartbeta') {
            window.location.href = '/vaneck-etfs/?page=etf-selector&assetClass=eq-smart-beta&investmentObjective=io-income,io-growth,io-sustainability-esg,io-international-diversification,io-factor-driven-performance,io-australian-equity-diversification,io-special-interest';
        }
    });
});

